export * from './colors'
export * from './texts'
export * from './buttons'
export * from './statuses'
import { lightTheme as gojitsuLightTheme } from '@gojitsu/web-ui-core';

import { createTheme } from '@material-ui/core/styles';

export const lightTheme = createTheme({
  props: {
    MuiButton: {
      disableElevation: true,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
      },
    },
  },
  ...gojitsuLightTheme,
});